{
  "title": "Supplier Master",
  "subtitle": "Vendors goods are received from — used by Purchase Orders, Gate Entry, and GRN.",
  "addSupplier": "Add Supplier",
  "search": "Search suppliers...",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "code": "Code",
    "name": "Supplier Name",
    "gstin": "GSTIN",
    "contactPerson": "Contact Person",
    "phone": "Phone",
    "jobWorkVendor": "Job Work",
    "jobWorkVendorYes": "Job Work Vendor",
    "status": "Status"
  },
  "form": {
    "code": "Supplier Code",
    "name": "Supplier Name",
    "gstin": "GSTIN",
    "address": "Address",
    "contactPerson": "Contact Person",
    "phone": "Phone",
    "email": "Email",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "isJobWorkVendor": "Job Work Vendor",
    "isJobWorkVendorHint": "Job Work Orders only offer suppliers marked this way. The same supplier can still be used for normal purchases.",
    "validation": {
      "codeRequired": "Supplier code is required.",
      "nameRequired": "Supplier name is required."
    }
  },
  "discardChanges": "Discard Changes",
  "saveSupplier": "Save Supplier",
  "deleteSupplier": {
    "message": "This supplier will be permanently removed."
  }
}
